export default __webpack_public_path__ + "logo16d855dd.png";